// extracted by mini-css-extract-plugin
module.exports = {"archiveList":"style_archiveList__EURJb","item":"style_item__MXLA9"};